import React from 'react'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import ProtectionsTable from './components/ProtectionsTable'

type Props = {}

export default function ProtectionsPage({}: Props) {
  return (
    <TopNavigationLayoutPageContent type='default'>
      <div className='flex-space-between'>
        <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
          <h2 className='page--header'>Защиты</h2>
        </div>
      </div>
      <ProtectionsTable />
    </TopNavigationLayoutPageContent>
  )
}
